import { render, staticRenderFns } from "./refund-detail.vue?vue&type=template&id=59323948&scoped=true&"
import script from "./refund-detail.vue?vue&type=script&lang=js&"
export * from "./refund-detail.vue?vue&type=script&lang=js&"
import style0 from "./refund-detail.vue?vue&type=style&index=0&id=59323948&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59323948",
  null
  
)

export default component.exports